/**
 *
 *
 */

import { useEffect, useState } from 'react';
import { Content, Title, InputFormTable, Editor } from 'components';
import { Select, Input, Radio, InputNumber, Space } from 'antd';
import { ForwardingLocationApi } from 'api';
import { useUserStack } from 'store';
import MessageAlert from 'utils';

/**----------------------------------------
 * [Component] 총관리자: 상품등록 > 수령지
 * ----------------------------------------
 */
const SalesInformation_storeInformation = ({ defaultValue, onChange }) => {
  /* ===== INITIAL ===== */
  const userInfo = useUserStack();
  /* ===== STATE ===== */
  const [selected, setSelected] = useState(defaultValue ?? []);
  const [forwardingLocationList, setForwardingLocationList] = useState([]);

  /* ===== FUNCTION ===== */

  /**--------------------
   * 출고지 목록 조회
   * --------------------
   */
  const getLocationList = async () => {
    try {
      const { status, message, data } =
        await ForwardingLocationApi.getForwardingLocations({
          shop_information_id: userInfo.shop_information_id,
        });
      if (status !== 200) throw { message };

      setTimeout(() => {
        setForwardingLocationList(
          data.filter((item) => item.type === 'RECEIVE')
        );
      }, 500);
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    getLocationList();
  }, []);
  /*  */
  useEffect(() => {
    onChange(selected);
  }, [selected]);
  /*  */
  // useEffect(() => {
  //   setSelected(defaultValue);
  // }, [defaultValue]);

  /* ===== VARIABLE ===== */

  console.log('forwardingLocationList: ', forwardingLocationList);

  /* ===== RENDER ===== */
  return (
    <>
      <Select
        allowClear
        style={{
          width: 700,
        }}
        name="regular_cycle"
        mode="multiple"
        // defaultValue={null}
        // value={data.regular_cycle}
        // onChange={(values) => console.log(values)}
        onChange={(values) =>
          setSelected(
            values.map((value) => ({ forwarding_location_id: value }))
          )
        }
        placeholder="픽업장소를 선택해주세요"
        options={forwardingLocationList.map((item) => ({
          label: (
            <span>
              {item.forwarding_name}
              <small style={{ fontSize: '0.85em', letterSpacing: -0.5 }}>
                ({item.forwarding_address})
              </small>
            </span>
          ),
          value: item.forwarding_location_id,
        }))}
      />
    </>
  );
};

SalesInformation_storeInformation.defaultProps = {
  defaultValue: null,
  onChange: () => {},
};
export default SalesInformation_storeInformation;
